$(function() {
  let scroll = 0;
  $(window).on('scroll', function () {
    const currentScroll = $(this).scrollTop();

    if (currentScroll > 100) {
      $('body').addClass('is-scrolled');

      if (currentScroll < scroll) {
        $('.tf-header, .tf-header__toggle').addClass('is-show');
      } else {
        $('.tf-header, .tf-header__toggle').removeClass('is-show');
      }
    } else {
      $('body').removeClass('is-scrolled');
      $('.tf-header, .tf-header__toggle').addClass('is-show');
    }

    scroll = currentScroll;
  });

  const menuBtn = $('.tf-header__toggle');
  menuBtn.on('click', function () {
    const isExpanded = $(this).attr('aria-expanded') === 'true';

    $('body').toggleClass('show-menu');
    $(this).attr('aria-expanded', (!isExpanded).toString());
  });
  
  $('.footer-nav__toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $button = $(this);
    const $column = $button.closest('.footer-nav__column');
    const isOpened = $column.hasClass('is-opened');

    $column.toggleClass('is-opened');
    $button.attr('aria-expanded', !isOpened);
  });
});
